import { render } from "./AdminTowers.vue?vue&type=template&id=0304dfd4"
import script from "./admintowers.js?vue&type=script&lang=js&external"
export * from "./admintowers.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__